import { Link } from "react-router-dom";
import { useGetPageQuery } from "../store/api/contentApi";

const FALLBACK_SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    body: `By accessing or using the Contentour Bonaire booking platform, you agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree to these terms, you may not access or use our services.`,
  },
  {
    title: "2. Booking and Payments",
    body: `When you place a booking through our platform, you are entering into a contract for services. All prices displayed are inclusive of applicable taxes unless stated otherwise. Payment is due at the time of booking and is processed through our secure payment gateway.`,
  },
  {
    title: "3. Cancellation and Refund Policy",
    body: `All bookings are final and non-refundable. Once a booking is confirmed and payment has been processed, no refunds will be issued under any circumstances, including cancellations, no-shows, or rescheduling requests.`,
  },
  {
    title: "4. Contact Us",
    body: `If you have any questions about these Terms and Conditions, please contact us at: hello@contentour.com`,
  },
];

export default function TermsConditions() {
  const { data: pageRes, isLoading } = useGetPageQuery("terms");
  const pageBody = pageRes?.data?.body || null;

  return (
    <div>
      {/* Hero banner */}
      <div className="relative bg-[#1a7b7b]">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute -top-10 -right-10 w-52 md:w-72 opacity-80"
            style={{
              background: "linear-gradient(135deg, #a8edea 0%, #fed6e3 40%, #c3f0e8 70%, #b8d4f8 100%)",
              borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
              height: "220px",
              filter: "blur(2px)",
            }}
          />
          <div
            className="absolute -bottom-10 -left-10 w-40 md:w-56 opacity-50"
            style={{
              background: "linear-gradient(135deg, #c3f0e8 0%, #a8edea 50%, #fed6e3 100%)",
              borderRadius: "70% 30% 30% 70% / 70% 70% 30% 30%",
              height: "180px",
              filter: "blur(2px)",
            }}
          />
        </div>

        <div className="container mx-auto px-4 py-14 md:py-20 flex flex-col items-center gap-4 relative z-10">
          <div className="flex flex-wrap items-center justify-center gap-1 text-white/70 font-manrope-regular text-sm">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <span>/</span>
            <span className="text-white">Terms &amp; conditions</span>
          </div>
          <h1 className="font-manrope-bold text-[28px] md:text-[48px] text-white text-center">
            Terms &amp; conditions
          </h1>
          <p className="font-manrope-regular text-sm text-white/70">
            Last updated: April 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-bg py-12 md:py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="bg-white rounded-2xl p-6 md:p-10 shadow-sm flex flex-col gap-8">
            <p className="font-manrope-regular text-base text-secondary leading-relaxed">
              These Terms and Conditions govern your use of the Contentour Bonaire booking platform and the services available through it. By accessing or using our platform, you confirm that you have read, understood, and agree to be bound by these Terms.
            </p>

            {isLoading && (
              <div className="flex flex-col gap-6 animate-pulse">
                {Array.from({ length: 4 }).map((_, i) => (
                  <div key={i} className="flex flex-col gap-2">
                    <div className="h-5 bg-gray-200 rounded w-48" />
                    <div className="h-4 bg-gray-100 rounded w-full" />
                    <div className="h-4 bg-gray-100 rounded w-4/5" />
                  </div>
                ))}
              </div>
            )}

            {!isLoading && pageBody ? (
              <div
                className="rich-content"
                dangerouslySetInnerHTML={{ __html: pageBody }}
              />
            ) : !isLoading && (
              FALLBACK_SECTIONS.map(({ title, body }) => (
                <div key={title} className="flex flex-col gap-3">
                  <h2 className="font-manrope-bold text-lg text-black">{title}</h2>
                  <p className="font-manrope-regular text-base text-secondary leading-relaxed">{body}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
